import React from "react";
import { NavLink, Link, withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import firebase from "firebase";
// import FontAwesome from "react-fontawesome";
// import { FaMapMarkedAlt } from "react-icons/fa";

const MenuItems = ({ drawerToggleOnClick, history }) => {
  const { user } = useSelector((state) => ({ ...state }));

  let dispatch = useDispatch();

  const logout = () => {
    firebase.auth().signOut();
    dispatch({
      type: "LOGOUT",
      payload: null,
    });
    history.push("/login");
  };

  const privateRoute = () => {
    console.log("Nedd to redirect to private profile");
  };

  return (
    <>
      <div className="rightNav"></div>

      <div className="leftNav">
        {user ? (
          <>
            {user.picture && (
              <li className="">
                <Link
                  to="/user/dashboard"
                  onClick={(drawerToggleOnClick, privateRoute)}
                >
                  <img
                    src={user.picture}
                    alt="profile pic"
                    className="profPic"
                  />
                </Link>{" "}
              </li>
            )}
            <li className="">
              <Link to="/user/events" onClick={drawerToggleOnClick}>
                My Events
              </Link>{" "}
            </li>
            <li className="">
              <Link to="" onClick={(drawerToggleOnClick, logout)}>
                Logout
              </Link>{" "}
            </li>
            {/* <li className="">
              <Link to="/" onClick={drawerToggleOnClick}>
                Home
              </Link>{" "}
            </li> */}
          </>
        ) : (
          <>
            <li className="">
              <NavLink to="/login" onClick={drawerToggleOnClick}>
                LogIn
              </NavLink>{" "}
            </li>
            <li className="">
              <NavLink to="/register" onClick={drawerToggleOnClick}>
                Register
              </NavLink>{" "}
            </li>
          </>
        )}
      </div>
    </>
  );
};
export default withRouter(MenuItems);
